<template>
  <div class="about-page">
    <section class="about-hero">
      <h1>Technology services at the core, powered by diversified operations</h1>
      <p class="desc">
        Built on technical services, technology development and technical consulting, we extend into IoT R&amp;D,
        AI hardware, electronic products, jewelry and daily consumer goods, supported by domestic trade agency,
        internet sales, import and export agency and international freight forwarding — providing reliable
        partnership for our clients worldwide.
      </p>
    </section>

    <div class="content-body">
      <section class="about-grid">
        <article class="card">
          <h3>Technology Services</h3>
          <p>Technology development, technical consulting, technical exchange, technology transfer and promotion, supported by network technology and IT consulting services.</p>
        </article>
        <article class="card">
          <h3>Products &amp; R&amp;D</h3>
          <p>Focused on IoT technology R&amp;D and technical services, AI hardware, commercial cryptography products, and the manufacture and sale of other electronic devices.</p>
        </article>
        <article class="card">
          <h3>Trade &amp; Logistics</h3>
          <p>Domestic trade agency, internet sales, import and export of goods and technology, import/export agency and international freight forwarding in one coordinated system.</p>
        </article>
      </section>

      <section class="timeline">
        <h2>Standard Engagement Process</h2>
        <div class="steps">
          <div class="step">
            <h4>01 / Discovery</h4>
            <p>Define technical requirements, product categories and delivery goals, then propose a matching solution and commercial path.</p>
          </div>
          <div class="step">
            <h4>02 / Delivery</h4>
            <p>Advance technology development, product supply and channel onboarding, completing delivery and acceptance milestone by milestone.</p>
          </div>
          <div class="step">
            <h4>03 / Fulfillment &amp; Review</h4>
            <p>Follow up on logistics fulfillment, after-sales support and partnership review to continuously improve cooperation efficiency.</p>
          </div>
        </div>
      </section>

      <section class="metrics">
        <div class="metric">
          <p class="num">Multi-Category</p>
          <p class="txt">Spanning technology, smart hardware, jewelry &amp; crafts and everyday consumer goods</p>
        </div>
        <div class="metric">
          <p class="num">End-to-End</p>
          <p class="txt">A closed loop from R&amp;D and production to trade agency and logistics fulfillment</p>
        </div>
        <div class="metric">
          <p class="num">Compliant</p>
          <p class="txt">Operating within applicable laws and regulatory requirements</p>
        </div>
      </section>

      <section class="company">
        <h2>Company Information</h2>
        <ul class="company-list">
          <li>
            <span class="k">Legal Name</span>
            <span class="v">FUN GRAFFITI STREET HATS LLC (as registered in the jurisdiction of incorporation)</span>
          </li>
          <li>
            <span class="k">Legal Name (English)</span>
            <span class="v">FUN GRAFFITI STREET HATS LLC</span>
          </li>
          <li>
            <span class="k">Registration No.</span>
            <span class="v">41-3903563</span>
          </li>
          <li>
            <span class="k">Registered Address</span>
            <span class="v">2800 E 12TH ST LOS ANGELES, CA 90023</span>
          </li>
          <li>
            <span class="k">Jurisdiction</span>
            <span class="v">United States of America</span>
          </li>
          <li>
            <span class="k">License Expiry Date</span>
            <span class="v">None (no fixed expiration term)</span>
          </li>
        </ul>
      </section>

      <section class="company">
        <h2>Business Activities</h2>
        <div class="scope-block">
          <h3 class="scope-title">Technology Services &amp; Consulting</h3>
          <p class="scope-text">
            Technical services, technology development, technical consulting, technical exchange, technology transfer and technology promotion; network technology services; information technology consulting services.
          </p>
        </div>
        <div class="scope-block">
          <h3 class="scope-title">IoT &amp; Artificial Intelligence</h3>
          <p class="scope-text">
            IoT technology research &amp; development and IoT technical services; AI hardware sales; electronic products sales; other electronic device manufacturing; security and commercial cryptography products development and sales.
          </p>
        </div>
        <div class="scope-block">
          <h3 class="scope-title">Retail &amp; E-commerce</h3>
          <p class="scope-text">
            Jewelry manufacturing and retail; retail of arts, crafts and collectibles (excluding ivory and its products); gifts and flowers; daily necessities; apparel and accessories; outdoor products; lighting fixtures; hardware products; automotive parts; computer hardware, software and peripherals; communication equipment; prepackaged food sales and online food sales; internet sales of goods.
          </p>
        </div>
        <div class="scope-block">
          <h3 class="scope-title">Trade &amp; Logistics</h3>
          <p class="scope-text">
            Domestic trade agency; import and export of goods; import and export of technology; import and export agency; international freight forwarding; road freight transportation (excluding hazardous goods).
          </p>
        </div>
        <p class="scope-note">
          FUN GRAFFITI STREET HATS LLC conducts the above activities within the scope of applicable laws and regulatory requirements; activities requiring licenses, qualifications or approvals are carried out only after such approvals have been obtained.
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutView"
};
</script>

<style scoped>
.about-page {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px 0;
  color: #eff5f8;
}

.about-hero {
  margin-bottom: 48px;
  text-align: center;
}


h1 {
  margin: 12px 0 16px;
  font-size: 32px;
  line-height: 1.3;
}

.desc {
  margin: 0 auto;
  max-width: 640px;
  color: #a2a4ad;
  line-height: 1.8;
  font-size: 15px;
}

.content-body {
  display: flex;
  flex-direction: column;
  gap: 48px;
}

h2 {
  margin: 0 0 24px;
  font-size: 22px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 12px;
}

.about-grid {
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(3, 1fr);
}

.card h3 {
  margin: 0 0 8px;
  font-size: 18px;
  color: var(--accent);
}

.card p, .step p {
  margin: 0;
  line-height: 1.7;
  color: #a2a4ad;
  font-size: 14px;
}

.steps {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.step h4 {
  margin: 0 0 8px;
  font-size: 16px;
}

.metrics {
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 32px;
}

.metric {
  text-align: center;
}

.num {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 700;
  color: var(--accent-soft);
}

.txt {
  margin: 0;
  color: #a2a4ad;
  line-height: 1.5;
  font-size: 14px;
}

.company-list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 12px;
}

.company-list li {
  display: grid;
  grid-template-columns: 160px 1fr;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.company-list .k {
  color: var(--accent-soft);
  font-size: 13px;
  font-weight: 700;
}

.company-list .v {
  color: #eff5f8;
  font-size: 14px;
  line-height: 1.6;
  word-break: break-word;
}

.scope-block {
  padding: 14px 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.scope-block + .scope-block {
  margin-top: 12px;
}

.scope-title {
  margin: 0 0 8px;
  font-size: 15px;
  color: var(--accent);
}

.scope-text {
  margin: 0;
  color: #a2a4ad;
  font-size: 14px;
  line-height: 1.9;
}

.scope-text + .scope-text {
  margin-top: 8px;
}

.scope-note {
  margin: 14px 0 0;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(244, 67, 108, 0.1);
  border: 1px solid rgba(244, 67, 108, 0.24);
  color: #eff5f8;
  font-size: 13px;
  line-height: 1.8;
}

@media (max-width: 900px) {
  .about-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 24px;
  }
}

@media (max-width: 768px) {
  .about-page {
    padding: 8px 0 0;
  }

  .about-hero {
    margin-bottom: 32px;
  }

  h1 {
    font-size: 26px;
  }

  .desc {
    font-size: 14px;
    line-height: 1.7;
  }

  .content-body {
    gap: 32px;
  }

  h2 {
    font-size: 20px;
    margin-bottom: 18px;
  }

  .about-grid,
  .metrics {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .metrics {
    padding-top: 24px;
  }

  .steps {
    gap: 18px;
  }
}

@media (max-width: 640px) {
  .company-list li {
    grid-template-columns: 1fr;
    gap: 4px;
  }

  .scope-block {
    padding: 12px 14px;
  }

  .scope-text {
    font-size: 13px;
    line-height: 1.8;
  }

  .scope-note {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  h1 {
    font-size: 23px;
  }

  .card h3 {
    font-size: 16px;
  }

  .num {
    font-size: 18px;
  }
}
</style>
